export default __webpack_public_path__ + "static/IMG_0179-c44f6a2317b20b975b99cc82fac972ad.jpg";